import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services';
import { AuthService } from '@ml/auth/services';
import { catchError, first, map } from 'rxjs/operators';
import { User } from '@ml/core/types/classes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.hasTokens) {
      const url = state.url.split('?')[0];
      this.router.navigate(['/auth'], {
        queryParams: {
          url,
          queryParams: JSON.stringify(next.queryParams)
        }
      });
      return false;
    }

    return this.userService.get().pipe(
      first(),
      map((user: User) => {
        if (user && !user.passwordChanged) {
          /*
          this.router.navigate(['change-password']);
          */
        }
        return true;
      }),
      catchError(err => {
        this.authService.logout();
        return this.router.navigate(['auth']);
      })
    );
  }
}
